import { Tabs as RTabs } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export const Tabs = RTabs.Root;
export const TabsContent = (p: ComponentProps<typeof RTabs.Content>) => (
  <RTabs.Content {...p} className={cn('focus:outline-none', p.className)} />
);

export function TabsList({ className, ...p }: ComponentProps<typeof RTabs.List>) {
  return (
    <RTabs.List
      {...p}
      className={cn('flex gap-4 overflow-x-auto border-b border-border [scrollbar-width:none]', className)}
    />
  );
}

/** Underline tabs: active = fg text with a blue underline. */
export function TabsTrigger({ className, children, ...p }: ComponentProps<typeof RTabs.Trigger>) {
  return (
    <RTabs.Trigger
      {...p}
      className={cn(
        '-mb-px h-9 shrink-0 border-b-2 border-transparent text-sm font-medium text-muted transition-colors hover:text-fg',
        'data-[state=active]:border-accent data-[state=active]:text-fg',
        className,
      )}
    >
      {children}
    </RTabs.Trigger>
  );
}
